$(document).ready(function(){
  setTimeout(function(){
    var better_slide = new Swiper(".better_slide .swiper-container", {
      loop: true,
      spaceBetween: 10,
      centeredSlides: true,
      observer: true,
      observeParents: true,
      loopAdditionalSlides: 1,
      loopedSlides: 2,
      slidesPerView: 1.5,
      watchSlidesProgress: true, 
      preloadImages: true, 
      lazy: false, 
      navigation: {
        nextEl: '.better_slide .swiper-button-next',
        prevEl: '.better_slide .swiper-button-prev',
      },
      breakpoints: {
        1280: {
          slidesPerView: 5,
        },
        750: {
          slidesPerView: 3,
        },
      },
      on: {
        init: function () {
          this.slides.forEach((slide) => {
            const video = slide.querySelector('video');
            if (video) {
              video.load();
            }
          });
          playActiveSlideVideo(this);
        },
        slideChange: function () {
          playActiveSlideVideo(this);
        },
      },
    });

    function playActiveSlideVideo(swiper) {
      swiper.slides.forEach(slide => {
        const video = slide.querySelector('video');
        if (video) {
          video.pause();
          video.currentTime = 0; 
        }
      });

      const activeSlide = swiper.slides[swiper.activeIndex];
      const activeVideo = activeSlide ? activeSlide.querySelector('video') : null;
      if (activeVideo) {
        activeVideo.play().catch(() => {});
      }
    }
  }, 1000);
});
